/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}linear-progress`;
const classes = {
    INDETERMINATE: 'forge-linear-progress--indeterminate'
};
const selectors = {
    ROOT: '.forge-linear-progress',
    TRACK: '.track',
    PROGRESS: '.primary-bar'
};
const observedAttributes = {
    DETERMINATE: 'determinate',
    PROGRESS: 'progress',
    BUFFER: 'buffer',
    THEME: 'theme'
};
const attributes = {
    ...observedAttributes
};
export const LINEAR_PROGRESS_CONSTANTS = {
    elementName,
    classes,
    selectors,
    attributes,
    observedAttributes
};
